import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19bb25bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "s-badge s-badge--follow"
}
const _hoisted_2 = {
  key: 1,
  class: "s-badge s-badge--interrupted"
}
const _hoisted_3 = {
  key: 2,
  class: "s-badge"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "s-top" }
const _hoisted_7 = { class: "s-tags" }
const _hoisted_8 = { class: "s-body" }
const _hoisted_9 = { class: "s-chart-wrap" }
const _hoisted_10 = { class: "s-legend" }
const _hoisted_11 = { class: "legend-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 策略收益（模拟） ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-item" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "legend-line legend-line--gray" }),
  /*#__PURE__*/_createTextVNode(" 沪深300 ")
], -1))
const _hoisted_14 = {
  key: 1,
  class: "s-chart s-chart--empty"
}
const _hoisted_15 = { class: "s-data" }
const _hoisted_16 = { class: "s-data-main" }
const _hoisted_17 = { class: "s-data-sub" }
const _hoisted_18 = { class: "s-data-sub-item" }
const _hoisted_19 = { class: "s-data-sub-item" }
const _hoisted_20 = { class: "tooltip-date" }
const _hoisted_21 = { class: "tooltip-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltip-label" }, "策略收益（模拟）", -1))
const _hoisted_23 = { class: "tooltip-row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "legend-line legend-line--gray" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltip-label" }, "沪深300", -1))
const _hoisted_26 = {
  class: "tooltip-val",
  style: {"color":"#26a17b"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "s-card",
    style: _normalizeStyle({ background: _ctx.cardBg })
  }, [
    (_ctx.item.followStatus === 'following')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "跟投中"))
      : (_ctx.item.followStatus === 'interrupted')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "跟投中断"))
        : (_ctx.item.rightTag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.item.rightTag.url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.item.rightTag.url,
                    class: "s-badge-img"
                  }, null, 8, _hoisted_4))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.item.rightTag.content), 1))
            ]))
          : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "s-name",
        style: _normalizeStyle({ color: _ctx.colors.textPrimary })
      }, _toDisplayString(_ctx.item.name), 5),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.leftTags, (tag) => {
          return (_openBlock(), _createElementBlock("span", {
            key: tag.content,
            class: _normalizeClass(["s-tag-type", tag.content === '个股量化' ? 'tag-stock' : 'tag-group'])
          }, _toDisplayString(tag.content), 3))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createElementVNode("i", {
              class: "legend-line",
              style: _normalizeStyle({ background: _ctx.strategyColor })
            }, null, 4),
            _hoisted_12
          ]),
          _hoisted_13
        ]),
        (_ctx.hasChartData)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "chartRef",
              class: "s-chart",
              onMousemove: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChartMouseMove && _ctx.onChartMouseMove(...args))),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tooltip.visible = false))
            }, null, 544))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("span", {
                class: "s-chart-empty-text",
                style: _normalizeStyle({ color: _ctx.colors.textMuted })
              }, "暂无收益", 4)
            ]))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", {
            class: "s-return",
            style: _normalizeStyle({ color: _ctx.returnColor })
          }, _toDisplayString(_ctx.formatReturn(_ctx.item.strategyReturn)), 5),
          _createElementVNode("span", {
            class: "s-return-label",
            style: _normalizeStyle({ color: _ctx.colors.textMuted })
          }, "策略收益(模拟)", 4)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", {
              class: "s-sub-val",
              style: _normalizeStyle({ color: _ctx.colors.textPrimary })
            }, _toDisplayString(_ctx.item.winRate != null ? Math.floor(_ctx.item.winRate * 100 * 100) / 100 + '%' : '--'), 5),
            _createElementVNode("span", {
              class: "s-sub-label",
              style: _normalizeStyle({ color: _ctx.colors.textMuted })
            }, "平均胜率", 4)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", {
              class: "s-sub-val",
              style: _normalizeStyle({ color: _ctx.colors.textPrimary })
            }, _toDisplayString(_ctx.formatNumber(_ctx.item.profitLossRatio, 3)), 5),
            _createElementVNode("span", {
              class: "s-sub-label",
              style: _normalizeStyle({ color: _ctx.colors.textMuted })
            }, "盈亏比", 4)
          ])
        ]),
        _createElementVNode("button", {
          class: "s-btn btn-follow",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBtnClick && _ctx.handleBtnClick(...args)))
        }, "查看详情")
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.tooltip.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "s-tooltip",
            style: _normalizeStyle({ left: _ctx.tooltip.x + 'px', top: _ctx.tooltip.y + 'px' })
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createTextVNode(_toDisplayString(_ctx.tooltip.date) + " ", 1),
              (_ctx.tooltip.eventType)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["tooltip-event-tag", `event-${_ctx.tooltip.eventType}`])
                  }, _toDisplayString(_ctx.eventTypeLabel(_ctx.tooltip.eventType)), 3))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("i", {
                class: "legend-line",
                style: _normalizeStyle({ background: _ctx.strategyColor })
              }, null, 4),
              _hoisted_22,
              _createElementVNode("span", {
                class: "tooltip-val",
                style: _normalizeStyle({ color: _ctx.strategyColor })
              }, _toDisplayString(_ctx.tooltip.strategyVal), 5)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25,
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.tooltip.benchmarkVal), 1)
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 4))
}